import { z } from 'zod';

import type { LRT_POSITION_RANGE, LRT_RUN_STATUS } from '../dictionary';

/** Id of a Local Rank Tracker report. */
export const LrtReportIdSchema = z.number();
/** Id of a Local Rank Tracker report. */
export type LrtReportId = z.infer<typeof LrtReportIdSchema>;

/** Union of LRT run status values: "successful" | "failed". */
export type LrtRunStatus = (typeof LRT_RUN_STATUS)[keyof typeof LRT_RUN_STATUS];

/** Union of the position ranges a run counts its keywords in. */
export type LrtPositionRange = (typeof LRT_POSITION_RANGE)[keyof typeof LRT_POSITION_RANGE];
